<template>
  <div id="app">
    <Header />
    <Sidebar>
      <ul class="sidebar-panel-nav">
        <li @click="toggle">
          <router-link to="/" @click="toggle">
            {{ $t("links.home") }}
          </router-link>
        </li>
        <li @click="toggle">
          <router-link to="/onlineconsultation">{{
            $t("links.onlineconsultation")
          }}</router-link>
        </li>
        <li @click="toggle">
          <router-link to="/online/assessment/routine">{{
            $t("links.skincareassessment")
          }}</router-link>
        </li>
        <li @click="toggle">
          <router-lin>
            <a href="https://reservations.beauteintegrale.ca/v2/#book" target="_blank">{{
            $t("links.athome")
          }}</a>
          </router-lin>
        </li>
        <li @click="toggle">
          <router-link to="/clinic">{{ $t("links.retailclinic") }}</router-link>
        </li>
        <li @click="toggle">
          <a href="https://moncoachbeaute.ca" target="_blank">{{
            $t("links.giftcards")
          }}</a>
        </li>
        <!-- <li @click="toggle">
          <router-link to="/social">{{ $t("links.socialmedia") }}</router-link>
        </li>
        <li @click="toggle">
          <router-link to="/blog">{{ $t("links.tutorials") }}</router-link>
        </li> -->
        <li @click="toggle">
          <router-link to="/faqs">{{ $t("links.faqs") }}</router-link>
        </li>
        <li><changelocale /></li>
      </ul>
    </Sidebar>
    <main class="maincontent">
      <router-view></router-view>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Sidebar from "@/components/Sidebar.vue";
import changelocale from "@/components/buttons/ChangeLocale.vue";
import { store, mutations } from "@/store/store.js";

export default {
  name: "app",
  components: {
    Footer,
    Header,
    Sidebar,
    changelocale,
  },
  data() {
    return {};
  },
  methods: {
    toggle() {
      mutations.toggleNav();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Gothic+A1:100,300,400,500,600,700,900&display=swap");
@import "./assets/main.css";

#app {
  font-family: "Gothic A1", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  min-height: 100vh;
}

main {
  margin-top: 0px;
  min-height: calc(100vh - 76px);
}

a {
  color: white;
}

.fade-in {
  animation: fadeIn ease 6s;
  -webkit-animation: fadeIn ease 6s;
  -moz-animation: fadeIn ease 6s;
  -o-animation: fadeIn ease 6s;
  -ms-animation: fadeIn ease 6s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue